/* eslint-disable no-unused-expressions */

import React from 'react'

import {
  CREATE_PROJECT_COLORS_STEP,
  CREATE_PROJECT_PAYMENT_STEP
} from '../constant'
import ProjectOptions from './ProjectOptions'

const ProjectUpgrades = ({ setStep = () => {}, type = 'create' }) => {
  const UPGRADES = 'upgrade'
  return (
    <div className='bg-menuGray min-h-screen relative mb-4'>
      <div className='p-6 bg-grey-8 rounded font-openSans'>
        <h1 className='font-black text-lg pt-3 font-openSans'>Upgrades</h1>
        <div className='border-b-2 border-black my-2'></div>
        <h2 className='font-openSans'>
          Does this project has some Upgrades and Options? Fill it here!
        </h2>
        <div className='mt-4 col-span-2'>
          <ProjectOptions viewMode={type} type={UPGRADES} setStep={setStep} prev={CREATE_PROJECT_COLORS_STEP} next={CREATE_PROJECT_PAYMENT_STEP} />
        </div>
      </div>
    </div>
  )
}

export default ProjectUpgrades
